import * as React from 'react';
import './coachProfile.module.scss';

import facebook from './images/sns-facebook.png';
import instagram from './images/sns-insta.png';
import twitter from './images/sns-twitter.png';
import { Coach } from '../../../types/coach';
import { observer } from 'mobx-react';
import { viewportState } from '../../../../commonv2/states/globalStates';
import { MarkdownText } from '../text/MarkdownText';

type Props = {
    coach: Coach;
};

class DesktopCoachProfile extends React.Component<Props> {
    render() {
        const { coach } = this.props;
        return (
            <div styleName="container">
                <img styleName="profile-image" src={coach.profile_photo_url} />
                <div styleName="details-container">
                    <div styleName="title">{coach.title}</div>
                    <div styleName="identity-container">
                        <div styleName="name">{coach.name}</div>
                        <div styleName="sns">
                            {coach.twitter && (
                                <a href={coach.twitter}>
                                    <img src={twitter} styleName="sns-image" />
                                </a>
                            )}
                            {coach.facebook && (
                                <a href={coach.facebook}>
                                    <img src={facebook} styleName="sns-image" />
                                </a>
                            )}
                            {coach.instagram && (
                                <a href={coach.instagram}>
                                    <img src={instagram} styleName="sns-image" />
                                </a>
                            )}
                        </div>
                    </div>
                    <div styleName="description">
                        <MarkdownText source={coach.profile} />
                    </div>
                    {/* <div styleName="more-description-link">
                        <Link to={V2Routes.coachDetailsPage(coach.id)}>講師について詳細を見る</Link>
                    </div> */}
                </div>
            </div>
        );
    }
}

class MobileCoachProfile extends React.Component<Props> {
    render() {
        const { coach } = this.props;
        return (
            <div styleName="container mobile">
                <div styleName="header">
                    <img styleName="profile-image" src={coach.profile_photo_url} />
                    <div styleName="details-container">
                        <div styleName="title">{coach.title}</div>
                        <div styleName="name">{coach.name}</div>
                        <div styleName="sns">
                            {coach.twitter && (
                                <a href={coach.twitter}>
                                    <img src={twitter} styleName="sns-image" />
                                </a>
                            )}
                            {coach.facebook && (
                                <a href={coach.facebook}>
                                    <img src={instagram} styleName="sns-image" />
                                </a>
                            )}
                            {coach.instagram && (
                                <a href={coach.instagram}>
                                    <img src={facebook} styleName="sns-image" />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
                <div styleName="body">
                    <div styleName="description">
                        <MarkdownText source={coach.profile} />
                    </div>
                    {/* <div styleName="more-description-link">
                        <Link to={V2Routes.coachDetailsPage(coach.id)}>講師について詳細を見る</Link>
                    </div> */}
                </div>
            </div>
        );
    }
}

@observer
export class CoachProfile extends React.Component<Props> {
    render() {
        const mobile = viewportState.isMobile;
        if (mobile) {
            return <MobileCoachProfile {...this.props} />;
        } else {
            return <DesktopCoachProfile {...this.props} />;
        }
    }
}
